import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// MUI
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

// Otis components
import MDBox from "components/MDBox";

function normalizeStatus(status) {
  return String(status ?? "").trim().toLowerCase();
}

function DataTableCellActions({
  status,
  loading = false,
  onActivate,
  onDeactivate,
  onDelete,
    onTmpx,
  iconColor = "#fff",
}) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const normalized = useMemo(() => normalizeStatus(status), [status]);

  const isActive = ["active", "activated", "enabled", "true", "1"].includes(normalized);
  const isDeactivated = ["inactive", "deactive", "deactivated", "disabled", "false", "0"].includes(
    normalized
  );

  const canDelete = true;

  const handleOpen = (event) => {
    if (loading) return;
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (event, action) => {
    event.stopPropagation();
    handleClose();
    action?.();
  };

  return (
    <MDBox display="flex" justifyContent="flex-end" minWidth={36}>
      {loading ? (
        <CircularProgress size={18} thickness={5} sx={{ color: iconColor }} />
      ) : (
        <>
          <IconButton size="small" onClick={handleOpen} sx={{ color: iconColor }}>
            <Icon fontSize="small">more_vert</Icon>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {isActive ? (
              <MenuItem onClick={(e) => handleAction(e, onDeactivate)}>
                <Icon fontSize="small" sx={{ mr: 1 }}>
                  block
                </Icon>
                {t("common.buttons.deactivate")}
              </MenuItem>
            ) : (
              <MenuItem onClick={(e) => handleAction(e, onActivate)}>
                <Icon fontSize="small" sx={{ mr: 1 }}>
                  check_circle
                </Icon>
                {t("common.buttons.activate")}
              </MenuItem>
            )}

            <Tooltip title={!canDelete ? t("common.table.deleteDisabledTooltip") : ""}>
              <span>
                <MenuItem
                  disabled={!canDelete}
                  onClick={(e) => handleAction(e, onDelete)}
                  sx={{ color: canDelete ? "error.main" : "text.secondary" }}
                >
                  <Icon fontSize="small" sx={{ mr: 1 }}>
                    delete
                  </Icon>
                  {t("common.buttons.delete")}
                </MenuItem>
              </span>
            </Tooltip>
          <MenuItem onClick={(e) => handleAction(e, onTmpx)}>
          <Icon fontSize="small" sx={{ mr: 1 }}>
          build
          </Icon>
          TMPx
          </MenuItem>
          </Menu>
        </>
      )}
    </MDBox>
  );
}

DataTableCellActions.propTypes = {
  status: PropTypes.any,
  loading: PropTypes.bool,
  onActivate: PropTypes.func,
  onDeactivate: PropTypes.func,
  onDelete: PropTypes.func,
  onTmpx: PropTypes.func,
  iconColor: PropTypes.string,
};

export default DataTableCellActions;
